import React from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-date-picker';
import classnames from 'classnames';

import { FormGroup, Label } from 'reactstrap';
import './date.css';

const DateField = ({
  field,
  form: { touched, errors, setFieldValue, setFieldTouched },
  ...props
}) => {
  const handleOnChange = date => {
    // react-date-picker invokes onChange with either:
    //  1) a valid Date instance (when the user picks a day or finishes typing)
    //  2) an empty string / partial string while the user is typing
    // Passing anything except a Date (or null) back into the component will
    // crash Safari because the library tries to read date methods on the
    // value.  We therefore store only complete Date objects in Formik; any
    // intermediate text is treated as "not yet set" (null).

    if (date instanceof Date && !isNaN(date.getTime())) {
      setFieldValue(field.name, date);
    } else {
      setFieldValue(field.name, null);
    }
    setFieldTouched(field.name, true);
  };

  const classes = classnames('form-control', {
    'is-invalid': errors[field.name] && touched[field.name]
  });
  const { t } = useTranslation('validation');

  return (
    <FormGroup>
      <Label>
        <b>{props.label}</b>
      </Label>
      <br />
      <DatePicker
        onChange={handleOnChange}
        value={field.value instanceof Date ? field.value : null}
        maxDate={props.maxDate}
        minDate={props.minDate}
        className={classes}
      />
      {errors[field.name] && touched[field.name] && (
        <div className="invalid-feedback d-block">{t(errors[field.name])}</div>
      )}
    </FormGroup>
  );
};

export { DateField };
